import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false); // ✅ loader
  const nav = useNavigate();

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

 const submitHandler = async (e) => {
  e.preventDefault();

  setLoading(true);
  setMessage("");

  const API_BASE =
    window.location.hostname === "localhost"
      ? "http://localhost:5400"
      : "https://admin.vascularirdoctors.com/backend";

  try {
    const res = await fetch(`${API_BASE}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginData),
    });

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error("Invalid server response");
    }

    if (res.ok) {
      localStorage.setItem("token", data.token);
      setMessage("Login successful ✅");

      setTimeout(() => {
        nav("/dashboard");
      }, 1000);
    } else {
      setMessage(data.message || "Login failed");
    }

  } catch (err) {
    console.log("LOGIN ERROR:", err);
    setMessage("Unable to connect to server ❌");
  }

  setLoading(false);
};
  return (
    <div className="authincation">
      <div className="container">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">

            <div className="authincation-content">
              <div className="auth-form">

                <h4 className="text-center mb-4">
                  Sign in your account
                </h4>

                <form onSubmit={submitHandler}>

                  <div className="form-group">
                    <label><strong>Email</strong></label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={loginData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label><strong>Password</strong></label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      value={loginData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="text-center mt-4">
                    <button
                      className="btn btn-primary btn-block"
                      disabled={loading}
                    >
                      {loading ? "Signing in..." : "Sign Me In"}
                    </button>
                  </div>

                  {/* ✅ PROFESSIONAL MESSAGE */}
                  {message && (
                    <div
                      style={{
                        marginTop: "15px",
                        textAlign: "center",
                        color: message.includes("successful") ? "green" : "red",
                        fontWeight: "600",
                      }}
                    >
                      {message}
                    </div>
                  )}

                </form>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;